import { FormComponent } from '@synergy/abstract';
import { Grid, Theme } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import { connect } from 'react-redux';

import { AppState } from '../../store/models/app-state';
import { Inquiry } from '../../common/models/inquiry';
import { Offer } from '../../common/models/offer';
import { OfferFooterConditions } from './offers-footer-conditions';

const styles = (theme: Theme) =>
    createStyles({
        container: {
            margin: '54px 65px 43px 62px',
            '& button': {
                float: 'right',
            },
        },
        conditionsText: {
            marginBottom: theme.spacing(2),
        },
    });

interface OffersFooterReduxProps extends WithStyles<typeof styles> {
    currency: string;
    termsOfDeliveryReadonly: boolean;
    termsOfPaymentReadonly: boolean;
    bonusReadonly: boolean;
    readonly: boolean;
}

interface OffersFooterOwnProps {
    inquiry?: Inquiry;
    onSubmit: () => void;
    onDecline: () => void;
}

type OffersFooterProps = OffersFooterReduxProps & OffersFooterOwnProps;

class OffersFooterBase extends FormComponent<Offer, OffersFooterProps> {
    public override render() {
        const { classes, bonusReadonly, termsOfDeliveryReadonly, termsOfPaymentReadonly, readonly } = this.props;

        return (
            <section id="conditions" className={classes.container}>
                <Grid container={true} spacing={4} alignItems="flex-end">
                    <Grid item={true} xs={12} md={8}>
                        <PoolTypography typography="h6" id="app.offers.conditions" className={classes.conditionsText} />
                        <PoolTypography
                            typography="body1"
                            id="app.offers.conditionsText"
                            className={classes.conditionsText}
                        />
                        <OfferFooterConditions
                            termsOfDeliveryReadonly={termsOfDeliveryReadonly || readonly}
                            termsOfPaymentReadonly={termsOfPaymentReadonly || readonly}
                            bonusReadonly={bonusReadonly || readonly}
                        />
                    </Grid>
                </Grid>
            </section>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    currency: state.settings.currency,
});

const ConnectedOffersFooter = connect(mapStateToProps)(OffersFooterBase);

export const OffersFooter = withStyles(styles)(ConnectedOffersFooter);
